/**
 * ioneaccess Authentication and User Aggregator (AUA) API
 * API for ioneacces Authenticator and User Aggregator (AUA). This document does not cover the OpenID Connect part!
 *
 * OpenAPI spec version: 1.1.2
 * Contact: christian.schlatter@ionesoft.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AWSCognitoTokenResponse } from '../model/aWSCognitoTokenResponse';
import { AttachPermissionDTO } from '../model/attachPermissionDTO';
import { CheckMembershipRequest } from '../model/checkMembershipRequest';
import { CloudMigrationResponse } from '../model/cloudMigrationResponse';
import { CreatePropertyTemplateRequest } from '../model/createPropertyTemplateRequest';
import { DetachPermissionDTO } from '../model/detachPermissionDTO';
import { GroupListResponse } from '../model/groupListResponse';
import { MigrationCallbackDTO } from '../model/migrationCallbackDTO';
import { PermissionAttachedResponse } from '../model/permissionAttachedResponse';
import { PermissionCreateResponse } from '../model/permissionCreateResponse';
import { PermissionDTO } from '../model/permissionDTO';
import { PermissionDeleteResponse } from '../model/permissionDeleteResponse';
import { PermissionDetachedResponse } from '../model/permissionDetachedResponse';
import { PermissionListResponse } from '../model/permissionListResponse';
import { PermissionSetResponse } from '../model/permissionSetResponse';
import { PropertyCreateTemplatesResponse } from '../model/propertyCreateTemplatesResponse';
import { PropertyGetTemplatesResponse } from '../model/propertyGetTemplatesResponse';
import { PropertyToggleTemplatesResponse } from '../model/propertyToggleTemplatesResponse';
import { ProviderListResponse } from '../model/providerListResponse';
import { ResolveRoleResponse } from '../model/resolveRoleResponse';
import { RoleCreateResponse } from '../model/roleCreateResponse';
import { RoleDTO } from '../model/roleDTO';
import { RoleDeleteResponse } from '../model/roleDeleteResponse';
import { RoleListResponse } from '../model/roleListResponse';
import { SetPermissionDTO } from '../model/setPermissionDTO';
import { TogglePropertyTemplateRequest } from '../model/togglePropertyTemplateRequest';
import { UserCheckMemebershipResponse } from '../model/userCheckMemebershipResponse';
import { UserDTO } from '../model/userDTO';
import { UserDeleteIdentityRequest } from '../model/userDeleteIdentityRequest';
import { UserDeleteIdentityResponse } from '../model/userDeleteIdentityResponse';
import { UserDeleteResponse } from '../model/userDeleteResponse';
import { UserExtendedSearchRequest } from '../model/userExtendedSearchRequest';
import { UserExtendedSearchResponse } from '../model/userExtendedSearchResponse';
import { UserExternalSearchRequest } from '../model/userExternalSearchRequest';
import { UserExternalSearchResponse } from '../model/userExternalSearchResponse';
import { UserGetForProviderRequest } from '../model/userGetForProviderRequest';
import { UserGetForProviderResponse } from '../model/userGetForProviderResponse';
import { UserGetGroupsGlobalResponse } from '../model/userGetGroupsGlobalResponse';
import { UserGetIdentitiesResponse } from '../model/userGetIdentitiesResponse';
import { UserGetPropertiesResponse } from '../model/userGetPropertiesResponse';
import { UserGetRequest } from '../model/userGetRequest';
import { UserGetResponse } from '../model/userGetResponse';
import { UserGetRolesResponse } from '../model/userGetRolesResponse';
import { UserLinkRequest } from '../model/userLinkRequest';
import { UserLinkResponse } from '../model/userLinkResponse';
import { UserQuickSearchRequest } from '../model/userQuickSearchRequest';
import { UserQuickSearchResponse } from '../model/userQuickSearchResponse';
import { UserSetEmailRequest } from '../model/userSetEmailRequest';
import { UserSetEmailResponse } from '../model/userSetEmailResponse';
import { UserSetGlobalResponse } from '../model/userSetGlobalResponse';
import { UserSetGroupsRequest } from '../model/userSetGroupsRequest';
import { UserSetPropertiesResponse } from '../model/userSetPropertiesResponse';
import { UserSetPropertyRequest } from '../model/userSetPropertyRequest';
import { UserSetResponse } from '../model/userSetResponse';
import { UserSetRolesRequest } from '../model/userSetRolesRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AUAClientService {

    protected basePath = 'https://igate.ionedev.com/aua/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Attach permission to existing role
     * Attach permissions to role. Permissions &amp; roles must exist.
     * @param body Array of roles with list of permissions to attach
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attachPermissions(body: Array<AttachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionAttachedResponse>;
    public attachPermissions(body: Array<AttachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionAttachedResponse>>;
    public attachPermissions(body: Array<AttachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionAttachedResponse>>;
    public attachPermissions(body: Array<AttachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling attachPermissions.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling attachPermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling attachPermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling attachPermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionAttachedResponse>('post',`${this.basePath}/role/attachPermission`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Check group membership
     * check group membership
     * @param body Check if caller is allowed to do action on subject
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkgroupMembership(body: CheckMembershipRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserCheckMemebershipResponse>;
    public checkgroupMembership(body: CheckMembershipRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserCheckMemebershipResponse>>;
    public checkgroupMembership(body: CheckMembershipRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserCheckMemebershipResponse>>;
    public checkgroupMembership(body: CheckMembershipRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling checkgroupMembership.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling checkgroupMembership.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling checkgroupMembership.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling checkgroupMembership.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserCheckMemebershipResponse>('post',`${this.basePath}/user/checkGroupMembership`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new set of permissions
     * Create a new set of permissions
     * @param body Array of roles
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionCreateResponse>;
    public createPermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionCreateResponse>>;
    public createPermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionCreateResponse>>;
    public createPermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createPermissions.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling createPermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling createPermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling createPermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionCreateResponse>('post',`${this.basePath}/permission/create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new template properties
     * Create new template properties
     * @param body Property template ro create
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPropertyTemplates(body: CreatePropertyTemplateRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PropertyCreateTemplatesResponse>;
    public createPropertyTemplates(body: CreatePropertyTemplateRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PropertyCreateTemplatesResponse>>;
    public createPropertyTemplates(body: CreatePropertyTemplateRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PropertyCreateTemplatesResponse>>;
    public createPropertyTemplates(body: CreatePropertyTemplateRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createPropertyTemplates.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling createPropertyTemplates.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling createPropertyTemplates.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling createPropertyTemplates.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PropertyCreateTemplatesResponse>('post',`${this.basePath}/property/createTemplates`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new roles and attach permissions
     * Create new roles and attach permissions. Permissions must exist.
     * @param body Array of roles
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRoles(body: Array<RoleDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<RoleCreateResponse>;
    public createRoles(body: Array<RoleDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleCreateResponse>>;
    public createRoles(body: Array<RoleDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleCreateResponse>>;
    public createRoles(body: Array<RoleDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createRoles.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling createRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling createRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling createRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleCreateResponse>('post',`${this.basePath}/role/create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * delete a identity from one specific user
     * delete a identity  from one specific user
     * @param body User Get Request
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteIdentityForUser(body: UserDeleteIdentityRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserDeleteIdentityResponse>;
    public deleteIdentityForUser(body: UserDeleteIdentityRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDeleteIdentityResponse>>;
    public deleteIdentityForUser(body: UserDeleteIdentityRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDeleteIdentityResponse>>;
    public deleteIdentityForUser(body: UserDeleteIdentityRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteIdentityForUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling deleteIdentityForUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling deleteIdentityForUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling deleteIdentityForUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDeleteIdentityResponse>('post',`${this.basePath}/user/deleteIdentity`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a set of permissions
     * Delete a set of permissions
     * @param body Array of permissions
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionDeleteResponse>;
    public deletePermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionDeleteResponse>>;
    public deletePermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionDeleteResponse>>;
    public deletePermissions(body: Array<PermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deletePermissions.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling deletePermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling deletePermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling deletePermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionDeleteResponse>('post',`${this.basePath}/permission/delete`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete roles, keep attached permissions
     * Delete roles, keep attached permissions
     * @param body Array of roles to delete
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<RoleDeleteResponse>;
    public deleteRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDeleteResponse>>;
    public deleteRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDeleteResponse>>;
    public deleteRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteRoles.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling deleteRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling deleteRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling deleteRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDeleteResponse>('post',`${this.basePath}/role/delete`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete IA users unscoped
     * Delete IA users unscoped
     * @param body Array of delete user requests
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserDeleteResponse>;
    public deleteUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDeleteResponse>>;
    public deleteUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDeleteResponse>>;
    public deleteUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteUsers.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling deleteUsers.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling deleteUsers.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling deleteUsers.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDeleteResponse>('post',`${this.basePath}/user/delete`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Detach permission to existing role
     * Detach permissions to role. Permissions &amp; roles must exist.
     * @param body Array of roles with list of permissions to detach
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public detachPermissions(body: Array<DetachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionDetachedResponse>;
    public detachPermissions(body: Array<DetachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionDetachedResponse>>;
    public detachPermissions(body: Array<DetachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionDetachedResponse>>;
    public detachPermissions(body: Array<DetachPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling detachPermissions.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling detachPermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling detachPermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling detachPermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionDetachedResponse>('post',`${this.basePath}/role/detachPermission`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Extended search for users by form data
     * Extended search for users
     * @param body Part of subject / givenName / familyName / email / provider / mandantGroup
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public extendedSearchUser(body: UserExtendedSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserExtendedSearchResponse>;
    public extendedSearchUser(body: UserExtendedSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserExtendedSearchResponse>>;
    public extendedSearchUser(body: UserExtendedSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserExtendedSearchResponse>>;
    public extendedSearchUser(body: UserExtendedSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling extendedSearchUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling extendedSearchUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling extendedSearchUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling extendedSearchUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserExtendedSearchResponse>('post',`${this.basePath}/user/extendedSearch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search for users by external id and provider
     * Search for users by provider info
     * @param body External search by external id and provider
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public externalSearchUser(body: UserExternalSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserExternalSearchResponse>;
    public externalSearchUser(body: UserExternalSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserExternalSearchResponse>>;
    public externalSearchUser(body: UserExternalSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserExternalSearchResponse>>;
    public externalSearchUser(body: UserExternalSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling externalSearchUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling externalSearchUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling externalSearchUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling externalSearchUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserExternalSearchResponse>('post',`${this.basePath}/user/externalSearch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Notify AUA about the finished cloud migration
     * Notify AUA about the finished cloud migration. Sets the corresponding properties on the migrated user.
     * @param X_Ia_Subject UUID of user
     * @param body User infos for migration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finalizeMigration(X_Ia_Subject: string, body?: MigrationCallbackDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public finalizeMigration(X_Ia_Subject: string, body?: MigrationCallbackDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public finalizeMigration(X_Ia_Subject: string, body?: MigrationCallbackDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public finalizeMigration(X_Ia_Subject: string, body?: MigrationCallbackDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling finalizeMigration.');
        }


        let headers = this.defaultHeaders;
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/user/finalizedCloudMigration`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get an AWS cognito identity token
     * Get an AWS cognito identity token for the specific user.
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAwsCognitoIdentityToken(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<AWSCognitoTokenResponse>;
    public getAwsCognitoIdentityToken(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AWSCognitoTokenResponse>>;
    public getAwsCognitoIdentityToken(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AWSCognitoTokenResponse>>;
    public getAwsCognitoIdentityToken(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getAwsCognitoIdentityToken.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getAwsCognitoIdentityToken.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getAwsCognitoIdentityToken.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AWSCognitoTokenResponse>('post',`${this.basePath}/user/getAwsCognitoToken`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return identities from one specific user
     * Return propidentitieserties from one specific user
     * @param body User Get Request
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIdentitiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetIdentitiesResponse>;
    public getIdentitiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetIdentitiesResponse>>;
    public getIdentitiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetIdentitiesResponse>>;
    public getIdentitiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getIdentitiesForUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getIdentitiesForUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getIdentitiesForUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getIdentitiesForUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetIdentitiesResponse>('post',`${this.basePath}/user/getIdentities`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get mandant groups for user
     * Get mandant groups user
     * @param body User get request for obtain groups
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMandantGroups(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetGroupsGlobalResponse>;
    public getMandantGroups(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetGroupsGlobalResponse>>;
    public getMandantGroups(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetGroupsGlobalResponse>>;
    public getMandantGroups(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getMandantGroups.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getMandantGroups.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getMandantGroups.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getMandantGroups.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetGroupsGlobalResponse>('post',`${this.basePath}/user/getMandantGroups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return  properties from one specific user
     * Return  properties from one specific user
     * @param body User Get Request
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPropertiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetPropertiesResponse>;
    public getPropertiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetPropertiesResponse>>;
    public getPropertiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetPropertiesResponse>>;
    public getPropertiesForUser(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getPropertiesForUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getPropertiesForUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getPropertiesForUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getPropertiesForUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetPropertiesResponse>('post',`${this.basePath}/user/getProperties`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return template properties
     * Return template properties
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPropertyTemplates(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PropertyGetTemplatesResponse>;
    public getPropertyTemplates(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PropertyGetTemplatesResponse>>;
    public getPropertyTemplates(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PropertyGetTemplatesResponse>>;
    public getPropertyTemplates(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getPropertyTemplates.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getPropertyTemplates.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getPropertyTemplates.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PropertyGetTemplatesResponse>('post',`${this.basePath}/property/listTemplates`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all providers
     * Get all providers
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProviders(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<ProviderListResponse>;
    public getProviders(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProviderListResponse>>;
    public getProviders(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProviderListResponse>>;
    public getProviders(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getProviders.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getProviders.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getProviders.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProviderListResponse>('post',`${this.basePath}/provider/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get roles from a specific user
     * Get roles from a specific user
     * @param body Array of roles to set on user
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoles(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetRolesResponse>;
    public getRoles(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetRolesResponse>>;
    public getRoles(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetRolesResponse>>;
    public getRoles(body: UserGetRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getRoles.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetRolesResponse>('post',`${this.basePath}/user/getRoles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get users specified by subjects
     * Get users specified by subjects
     * @param body Array of set property requests
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetResponse>;
    public getUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetResponse>>;
    public getUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetResponse>>;
    public getUsers(body: Array<UserGetRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getUsers.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getUsers.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getUsers.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getUsers.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetResponse>('post',`${this.basePath}/user/get`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get users specified by subjects
     * Get users specified by subjects
     * @param body Array of set property requests
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsersForProvider(body: Array<UserGetForProviderRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserGetForProviderResponse>;
    public getUsersForProvider(body: Array<UserGetForProviderRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGetForProviderResponse>>;
    public getUsersForProvider(body: Array<UserGetForProviderRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGetForProviderResponse>>;
    public getUsersForProvider(body: Array<UserGetForProviderRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getUsersForProvider.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling getUsersForProvider.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling getUsersForProvider.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling getUsersForProvider.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserGetForProviderResponse>('post',`${this.basePath}/user/getForProvider`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Link IA identitites
     * Link two or more IA identitites to a single IA identity. All IDs are merged with the oldest IA identity.
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param body Array with IA tokens to merge
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public linkIDs(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserLinkRequest, observe?: 'body', reportProgress?: boolean): Observable<UserLinkResponse>;
    public linkIDs(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserLinkRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserLinkResponse>>;
    public linkIDs(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserLinkRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserLinkResponse>>;
    public linkIDs(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserLinkRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling linkIDs.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling linkIDs.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling linkIDs.');
        }


        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserLinkResponse>('post',`${this.basePath}/user/link`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all mandant group names
     * Get all defined mandant group names
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listGroups(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<GroupListResponse>;
    public listGroups(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GroupListResponse>>;
    public listGroups(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GroupListResponse>>;
    public listGroups(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling listGroups.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling listGroups.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling listGroups.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GroupListResponse>('post',`${this.basePath}/group/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get all defined permissions
     * Get all defined permissions
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listPermissions(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionListResponse>;
    public listPermissions(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionListResponse>>;
    public listPermissions(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionListResponse>>;
    public listPermissions(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling listPermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling listPermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling listPermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PermissionListResponse>('post',`${this.basePath}/permission/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all roles
     * Get all defined roles
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listRoles(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<RoleListResponse>;
    public listRoles(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleListResponse>>;
    public listRoles(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleListResponse>>;
    public listRoles(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling listRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling listRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling listRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RoleListResponse>('post',`${this.basePath}/role/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Quick search for users
     * Quick search for users
     * @param body Part of email / subject / name or creation / provider date to search for
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quickSearchUser(body: UserQuickSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserQuickSearchResponse>;
    public quickSearchUser(body: UserQuickSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserQuickSearchResponse>>;
    public quickSearchUser(body: UserQuickSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserQuickSearchResponse>>;
    public quickSearchUser(body: UserQuickSearchRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling quickSearchUser.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling quickSearchUser.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling quickSearchUser.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling quickSearchUser.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserQuickSearchResponse>('post',`${this.basePath}/user/quickSearch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get permissions for roles
     * Get permissions for roles
     * @param body Array of roles
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resolveRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<ResolveRoleResponse>;
    public resolveRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResolveRoleResponse>>;
    public resolveRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResolveRoleResponse>>;
    public resolveRoles(body: Array<string>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling resolveRoles.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling resolveRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling resolveRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling resolveRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResolveRoleResponse>('post',`${this.basePath}/permission/resolveRoles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set email on one specific user
     * Set email on one specific user.
     * @param body Array of roles to set on user
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setEmail(body: UserSetEmailRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserSetEmailResponse>;
    public setEmail(body: UserSetEmailRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSetEmailResponse>>;
    public setEmail(body: UserSetEmailRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSetEmailResponse>>;
    public setEmail(body: UserSetEmailRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setEmail.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setEmail.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setEmail.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setEmail.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserSetEmailResponse>('post',`${this.basePath}/user/setEmail`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set mandant groups on specific user
     * Set mandant groups on specific user. Existing groups will be replaced. Not existing groups will be created. Either all groups can be set, or the request fails.
     * @param body Array of mandant groups with membership types to set on user
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setMandantGroups(body: UserSetGroupsRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserSetGlobalResponse>;
    public setMandantGroups(body: UserSetGroupsRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSetGlobalResponse>>;
    public setMandantGroups(body: UserSetGroupsRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSetGlobalResponse>>;
    public setMandantGroups(body: UserSetGroupsRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setMandantGroups.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setMandantGroups.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setMandantGroups.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setMandantGroups.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserSetGlobalResponse>('post',`${this.basePath}/user/setMandantGroups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set permission to existing role
     * Set permissions to role. Permissions &amp; roles must exist.
     * @param body Array of roles with list of permissions to attach
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPermissions(body: Array<SetPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PermissionSetResponse>;
    public setPermissions(body: Array<SetPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionSetResponse>>;
    public setPermissions(body: Array<SetPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionSetResponse>>;
    public setPermissions(body: Array<SetPermissionDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setPermissions.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setPermissions.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setPermissions.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setPermissions.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionSetResponse>('post',`${this.basePath}/role/setPermissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set properties on one specific user
     * Set properties on one specific user. Existing properties will be replaced.
     * @param body Array of set property requests
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setProperties(body: UserSetPropertyRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserSetPropertiesResponse>;
    public setProperties(body: UserSetPropertyRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSetPropertiesResponse>>;
    public setProperties(body: UserSetPropertyRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSetPropertiesResponse>>;
    public setProperties(body: UserSetPropertyRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setProperties.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setProperties.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setProperties.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setProperties.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserSetPropertiesResponse>('post',`${this.basePath}/user/setProperties`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set roles on one specific user
     * Set roles on one specific user. Existing roles will be replaced. All roles must exist. If one or more roles not exist, no roles will be appended. The set property is a transactional execution. Either all roles can be set, or the request fails.
     * @param body Array of roles to set on user
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setRoles(body: UserSetRolesRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserSetGlobalResponse>;
    public setRoles(body: UserSetRolesRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSetGlobalResponse>>;
    public setRoles(body: UserSetRolesRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSetGlobalResponse>>;
    public setRoles(body: UserSetRolesRequest, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setRoles.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setRoles.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setRoles.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setRoles.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserSetGlobalResponse>('post',`${this.basePath}/user/setRoles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set users information
     * Set users information
     * @param body Array of set user requests
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setUsers(body: Array<UserDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<UserSetResponse>;
    public setUsers(body: Array<UserDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSetResponse>>;
    public setUsers(body: Array<UserDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSetResponse>>;
    public setUsers(body: Array<UserDTO>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setUsers.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling setUsers.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling setUsers.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling setUsers.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserSetResponse>('post',`${this.basePath}/user/set`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start the cloud migration from HEP to beook.
     * Start the cloud migration from HEP to beook. No additional parameters are needed. Subject is taken from header, Encryption keys and Cognitos Id are stored in AUAs DB.
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param body User infos for migration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startCloudMigration(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserGetRequest, observe?: 'body', reportProgress?: boolean): Observable<CloudMigrationResponse>;
    public startCloudMigration(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserGetRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CloudMigrationResponse>>;
    public startCloudMigration(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserGetRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CloudMigrationResponse>>;
    public startCloudMigration(X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, body?: UserGetRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling startCloudMigration.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling startCloudMigration.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling startCloudMigration.');
        }


        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CloudMigrationResponse>('post',`${this.basePath}/user/startCloudMigration`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle template properties
     * Toggle template properties
     * @param body Array of property templates to toggle
     * @param X_Ia_Correlation_Id A UUID composed of IP and timestamp. Client creates passes ID to the first call.
     * @param X_Ia_Subject UUID of user
     * @param X_Ia_Roles Role of caller. One or many roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public togglePropertyTemplates(body: Array<TogglePropertyTemplateRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'body', reportProgress?: boolean): Observable<PropertyToggleTemplatesResponse>;
    public togglePropertyTemplates(body: Array<TogglePropertyTemplateRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PropertyToggleTemplatesResponse>>;
    public togglePropertyTemplates(body: Array<TogglePropertyTemplateRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PropertyToggleTemplatesResponse>>;
    public togglePropertyTemplates(body: Array<TogglePropertyTemplateRequest>, X_Ia_Correlation_Id: string, X_Ia_Subject: string, X_Ia_Roles: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling togglePropertyTemplates.');
        }

        if (X_Ia_Correlation_Id === null || X_Ia_Correlation_Id === undefined) {
            throw new Error('Required parameter X_Ia_Correlation_Id was null or undefined when calling togglePropertyTemplates.');
        }

        if (X_Ia_Subject === null || X_Ia_Subject === undefined) {
            throw new Error('Required parameter X_Ia_Subject was null or undefined when calling togglePropertyTemplates.');
        }

        if (X_Ia_Roles === null || X_Ia_Roles === undefined) {
            throw new Error('Required parameter X_Ia_Roles was null or undefined when calling togglePropertyTemplates.');
        }

        let headers = this.defaultHeaders;
        if (X_Ia_Correlation_Id !== undefined && X_Ia_Correlation_Id !== null) {
            headers = headers.set('X-Ia-Correlation-Id', String(X_Ia_Correlation_Id));
        }
        if (X_Ia_Subject !== undefined && X_Ia_Subject !== null) {
            headers = headers.set('X-Ia-Subject', String(X_Ia_Subject));
        }
        if (X_Ia_Roles !== undefined && X_Ia_Roles !== null) {
            headers = headers.set('X-Ia-Roles', String(X_Ia_Roles));
        }

        // authentication (AuthorizationHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PropertyToggleTemplatesResponse>('post',`${this.basePath}/property/toggleTemplates`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
